/* Encapsulates and collects all layout container dependent global calls */
export class TopoLayoutConnector {
    static GetMapContainer() {
        return $left;
    }

    static GetMapContainerWrapper() {
        return $lWrp;
    }

    static GetGalleryMapWrapper() {
        return $gMapWrp;
    }

    static GetResultContainer() {
        return $result;
    }

    static GetGallerySidepanelContainer() {
        return $gSidepanel;
    }

    static GetGalleryOverlayContainer() {
        return $gOverlay;
    }

    static GetGalleryContentContainer() {
        return $gContent;
    }

    static GetLWResizeableContainer() {
        return $lw_resizable;
    }

    static GetLWResizeIndicatorsContainer() {
        return $lw_resize_indicators;
    }
}
